<div fxLayout="column" class="w-100">
    <div class="input-wrapper default-note" fxLayout="column">
        <span class="label" i18n>Share file with</span>
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutGap.lt-md="10px">
            <mat-form-field class="small-field mt-1 users-rec-input" appearance="fill">
                <input
                    type="text"
                    matInput
                    #userRecieverInput
                    i18n-placeholder
                    placeholder="Search users"
                    [formControl]="userCtrl"
                    [matAutocomplete]="autoUser"
                />
                <mat-autocomplete #autoUser="matAutocomplete" (optionSelected)="selected(autoUser, $event)">
                    <mat-option *ngFor="let user of userSearch$ | async" [value]="user">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon> {{ user.role_value | userRoleIcon }}</mat-icon>
                            <span>{{ user.name }}</span>
                        </div>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div fxLayout="column wrap">
            <mat-chip-list
                *ngIf="userRecipients.length"
                class="reci-chips mb-1"
                #chipList
                aria-label="Recievers selection"
            >
                <mat-chip
                    *ngFor="let recipient of userRecipients"
                    (removed)="removeUser(recipient)"
                    [selectable]="false"
                    class="users-wrap"
                    [ngClass]="{
                        'dark-blue-bg': recipient.role_value === 'user',
                        'green-bg': recipient.role_value !== 'user'
                    }"
                >
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <mat-icon>{{ recipient.role_value | userRoleIcon }}</mat-icon>
                        <span>{{ recipient.fname }}</span>
                        <span> {{ recipient.lname }}</span>
                    </div>
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip></mat-chip-list
            >
        </div>
    </div>
</div>
